<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  import Index from './components/IndexNew.vue'

  export default {
    components: {Index},
    name: 'App'
  }
</script>

<style lang="less">
  body {
    padding-right: 0 !important;
    overflow-y: auto !important;
  }

  .swal2-container {
    .swal2-popup {
      width: 450px;

      .swal2-header {
        #swal2-title {
          color: #4285f4;
        }
      }

      .swal2-content {
        #swal2-content {
          font-size: 13px;
        }
      }

      .swal2-styled {
        &:focus {
          box-shadow: none;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/App.vue